import { Component, OnDestroy, OnInit } from '@angular/core';
import { FilterService } from 'libs/portal/src/services/filter/filter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-device-bundle-filter',
  templateUrl: './device-bundle-filter.component.html',
  styleUrls: ['./device-bundle-filter.component.scss'],
})
export class DeviceBundleFilterComponent implements OnInit, OnDestroy {
  constructor(private filterService: FilterService) {}

  rangeValues: any = { lower: 0, upper: 1000 };
  sub: Subscription;

  filter() {
    const filterObj = {
      bundle: this.rangeValues,
    };
    this.filterService.emit(filterObj);
  }

  ngOnInit() {
    this.sub = this.filterService.searchClickedEvent.subscribe((clicked) => {
      if (clicked) {
        this.filter();
      }
    });
  }

  ngOnDestroy(): void {
      this.sub.unsubscribe();
  }
}
